import { render, staticRenderFns } from "./SchoolProfile.vue?vue&type=template&id=2aa9e87e&"
import script from "./SchoolProfile.ts?vue&type=script&lang=ts&"
export * from "./SchoolProfile.ts?vue&type=script&lang=ts&"
import style0 from "@/views/School/school.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports